module.exports = __webpack_public_path__ + "assets/client/images/site-logo.svg";